import { odata } from "@azure/data-tables";
import { FirstAider } from "../interfaces/FirstAider";

export default async function iterateOverEntities(client: any, date: string, magicHouse: string): Promise<Array<FirstAider>> {
  const entities = client.listEntities({
    queryOptions: {
      filter: odata`date eq ${date} and magicHouse eq ${magicHouse}`,
    },
  });
  const firstAiders: Array<FirstAider> = [];

  for await (const entity of entities) {
    firstAiders.push({
      id: `${entity.partitionKey}${entity.rowKey}`,
      name: entity.name as string,
      surname: entity.surname as string,
      email: entity.email as string,
      phone: entity.phone as string,
      availability: entity.availability === true || entity.availability === "true",
      timestamp: new Date(entity.timestamp as string),
      magicHouse: entity.magicHouse as string,
      date: entity.date as string,
    });
  }

  return firstAiders;
}
